import { MutableRefObject, useEffect, useMemo, useRef, useState } from "react";
import { Background, CampaignImg, CampaignImgBg, CampaignImgDiv, GiftcardWidth, GiftcardWrapper, Wrapper, WrapperWhenBanner } from "./ExternFormEnrollment.styles";
import OccupationStep from "./Steps/OccupationStep";
import SalespersonStep from "./Steps/SalespersonStep";
import ProductStep from "./Steps/ProductStep";
import CircumstanceStep from "./Steps/CircumstanceStep";
import InformationStep from "./Steps/InformationStep";
import YourConsentStep from "./Steps/YourConsentStep";
import PaymentStep from "./Steps/PaymentStep";
import ThankYouStep from "./Steps/ThankYouStep";
import { useStore } from "../../store/store";
import ContactMeReciept from "./Steps/ContactMeReciept";
import { fetchTranslations, fetchUnemploymentInsuranceOptions, fetchUnionOptions } from "../../utils/api";
import { useWindowResize } from "../../hooks/useWindowResize";
import axios from "axios";
import { AccordionRoutesEnum } from "../../types/AccordionRoutes";
import GiftCardPopup from "../../components/GiftCardPopup";
import Analytics from "../../utils/analytics";
import { TrackingFlowTypeEnum } from "../../types/TrackingFlowTypeEnum";
import ProductStepV2 from "./Steps/ProductStepV2";
import Basket from "./components/Basket";
import HelpForm from "./components/HelpForm";
import { PayloadTypeEnum } from "../../types/PayloadTypeEnum";

export enum VisibleLayoutEnum {
  Accordion = "Accordion",
  ThankYou = "ThankYou",
  CallMeReciept = "CallMeReciept",
}

export default function ExternFormEnrollment() {

  const payload = useStore.usePayload();
  const translations = useStore.useTranslations();
  const switchLayout = useStore.useSwitchLayout();
  const accordionRoute = useStore.useAccordionRoute();
  const setCompletedAccordionRoute = useStore.useSetCompletedAccordionRoute();
  const setAccordionRoute = useStore.useSetAccordionRoute();
  const setTranslations = useStore.useSetTranslation();
  const setOfferEnabled = useStore.useSetOfferEnabled();
  const setDiscountCodesEnabled = useStore.useSetDiscountCodesEnabled();
  const setPayload = useStore.useSetPayload();
  const setUnemploymentInsuranceOptions = useStore.useSetUnimploymentInsuranceOptions();
  const setUnionOptions = useStore.useSetUnionOptions();
  const [showExitIntent, setShowExitIntent] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [campaignImgUrl, setCampaignImgUrl] = useState("");
  const [campaignMobileImgUrl, setCampaignMobileImgUrl] = useState("");
  const [source, setSource] = useState<string>();
  const windowSize = useWindowResize();
  const elementRef = useRef() as MutableRefObject<HTMLDivElement>;
  const getIpAddress = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json");
    setPayload({ ipAddress: res.data.ip });
  };
  const [step2, setStep2] = useState<AccordionRoutesEnum>(AccordionRoutesEnum.ProductStepV2);
  const isDesktop = useStore.useIsDesktop();
  const setIsDesktop = useStore.useSetIsDesktop();
  //Basket
  const [showHelpForm, setShowHelpform] = useState<boolean>(false);
  const [chosenProducts, setChosenProducts] = useState<string>();

  //Used for contact form in basket
  useEffect(() => {
    let products = [""];
    payload.wantsUnemploymentBenefits && products.push("akasse");
    payload.wantsUnion && products.push("fagforening");
    payload.wantsSalaryInsurance && products.push("loensikring");
    payload.wantsSalaryInsuranceAndUnion && products.push("fagforeningloensikring");
    payload.wantsBasic && products.push("basis");
    payload.wantsHRJura && products.push("hrjura");
    setChosenProducts(products.join(", "));
  }, [payload.wantsUnemploymentBenefits, payload.wantsUnion, payload.wantsSalaryInsurance, payload.wantsSalaryInsuranceAndUnion, payload.wantsBasic, payload.wantsHRJura]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let translations: any;
        const settingsUrl = form?.dataset.jsonSettingsUrl;

        translations = await fetchTranslations(settingsUrl);

        setTranslations(translations.data);

        const unemploymentInsuranceOptions = await fetchUnemploymentInsuranceOptions();
        const unionOptions = await fetchUnionOptions();

        setUnemploymentInsuranceOptions(unemploymentInsuranceOptions.data);
        setUnionOptions(unionOptions.data);

        // If an occupation is passed in the query string, set it as the default value
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const occupation = urlParams.get("type");

        if (occupation === "employee") {
          setPayload({ occupation: "Employee" });
        }
        if (occupation === "selfemployed") {
          setPayload({ occupation: "SelfEmployed" });
        }
        if (occupation === "unemployed") {
          setPayload({ occupation: "Unemployed" });
        }
        if (occupation === "student") {
          setPayload({ occupation: "Student" });
        }

        getIpAddress();
      } catch (err) {}
    };

    const form = document.querySelector(`[data-component='extern-form-enrollment']`) as HTMLElement;

    fetchData();

    const source = form?.dataset.source ?? "";
    const affiliate = form?.dataset.affiliate;
    const enableDiscounts = form?.dataset.enableDiscounts == "True" ? true : false;
    const nodeKey = form?.dataset.settingsNodeKey;
    const enableDiscountCodes = form?.dataset.enableDiscountcodes == "True" ? true : false;

    setOfferEnabled(enableDiscounts);
    setDiscountCodesEnabled(enableDiscountCodes);
    setPayload({ settingsNodeKey: nodeKey, source: source, affiliate: affiliate, payloadType: PayloadTypeEnum.ExternFormEnrollment.toString() });
    setSource(source);
    setAccordionRoute(AccordionRoutesEnum.SalespersonStep, payload, TrackingFlowTypeEnum.VerticalV2);
  }, []);

  //Getting img from Umbraco backend
  useEffect(() => {
    const form = document.querySelector(`[data-component='extern-form-enrollment']`) as HTMLElement;
    const imageUrl = form?.dataset.imageCampaignUrl;
    const mobileImageUrl = form?.dataset.imageMobileCampaignUrl;
    setCampaignImgUrl(`${imageUrl}`);
    setCampaignMobileImgUrl(`${mobileImageUrl}`);
  }, []);

  const currentWidth = useMemo(() => {
    return elementRef.current?.getBoundingClientRect().width;
  }, [windowSize]);

  const showGiftCardPopup = useMemo(() => {
    return switchLayout != VisibleLayoutEnum.ThankYou && switchLayout != VisibleLayoutEnum.CallMeReciept && accordionRoute != AccordionRoutesEnum.ContactMeStep;
  }, [accordionRoute, VisibleLayoutEnum]);

  //Check for window size
  useEffect(() => {
    handleResize();
  }, []);

  const handleResize = () => {
      setIsDesktop(false);
  };
  window.addEventListener("resize", handleResize);

  //Test of new OI
  //Check if occupation needs to be skipped
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const campaign = urlParams.get("campaign");

    if (campaign !== null) {
      setSource(source);
      setPayload({ source: campaign });
    }
  }, []);

  //Different productcards on mobile and desktop
  useEffect(() => {
    if (isDesktop) {
      setStep2(AccordionRoutesEnum.ProductStepV2);
    } else {
      setStep2(AccordionRoutesEnum.ProductStepV2);
    }
  }, [isDesktop]);

  return (
    <>
      {showGiftCardPopup === true && (
        <GiftcardWrapper>
          <GiftcardWidth>
            <GiftCardPopup isFront={true} source={source!} verticalOI={true} />
          </GiftcardWidth>
        </GiftcardWrapper>
      )}
      {switchLayout === VisibleLayoutEnum.Accordion && campaignImgUrl && (
        <CampaignImgDiv>
          <CampaignImgBg>
            {currentWidth < 768 && campaignMobileImgUrl && <CampaignImg src={campaignMobileImgUrl} alt="kampagne banner" />}
            {(currentWidth >= 768 || (currentWidth < 768 && !campaignMobileImgUrl)) && <CampaignImg src={campaignImgUrl} alt="kampagne banner" />}
          </CampaignImgBg>
        </CampaignImgDiv>
      )}
      {switchLayout === VisibleLayoutEnum.Accordion && (
        <>
          <Background marginTop={campaignImgUrl ? true : false} ref={elementRef} isDesktop={isDesktop}>
            <Wrapper isDesktop={isDesktop}>
              <WrapperWhenBanner show={campaignImgUrl ? true : false}>
                <SalespersonStep />
                <OccupationStep step2={step2} />
                {/* {step2 === AccordionRoutesEnum.ProductStep && <ProductStep />} */}
                {step2 === AccordionRoutesEnum.ProductStepV2 && <ProductStepV2 />}
                <CircumstanceStep step2={step2} />
                <InformationStep step2={step2} />
                <YourConsentStep step2={step2} />
                <PaymentStep step2={step2} />
              </WrapperWhenBanner>
            </Wrapper>
            {isDesktop && <Basket marginTop={campaignImgUrl ? true : false} openHelpForm={() => setShowHelpform(true)} />}
          </Background>
        </>
      )}
      {switchLayout === VisibleLayoutEnum.ThankYou && <ThankYouStep />}
      {switchLayout === VisibleLayoutEnum.CallMeReciept && <ContactMeReciept />}
      {showHelpForm && <HelpForm onClose={() => setShowHelpform(false)} chosenProducts={chosenProducts} />}
    </>
  );
}
